import {
  QuestionnaireResponsesType,
  TestQuestionnaireProps,
} from "@/common/types";
import { ScrollArea } from "@/components/ui/scroll-area";
import QuestionnaireResponse from "@/containers/questionnaire-detail/questionnaire-response";

const TestQuestionnaire: React.FC<TestQuestionnaireProps> = ({
  questionnaire,
}) => {
  return (
    <ScrollArea className="h-[calc(100vh-400px)] overflow-auto">
      {questionnaire &&
        questionnaire.responses &&
        questionnaire.responses.map((responseItem, index) => (
          <QuestionnaireResponse
            key={index}
            data={responseItem as QuestionnaireResponsesType}
          />
        ))}
    </ScrollArea>
  );
};

export default TestQuestionnaire;
